import styled from "styled-components";

export const BigTitle = styled.h2`
  color: black;
  font-size: 1.8rem;
  font-weight: bold;
  margin: 2rem 0 1rem 0;
`;

export const SubTitle = styled.h3`
  color: ${(props) => props.theme.colors.blackTextTitle};
  font-weight: 600;
  font-size: 1.4rem;
  margin: 1.5rem 0 0.6rem 0;
`;

export const Container = styled.div`
  margin-bottom: 4.2rem;
  margin-top: -3rem;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  .react-date-picker {
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 8px;
    border: none;
    box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.62);
    box-sizing: border-box;
    font-size: 1.5rem;
    font-weight: 500;
    height: 5rem;
    padding-left: 1.5rem;
    padding-right: 1rem;
    width: 25.6rem;
  }
  .react-date-picker__wrapper {
    border: none;
  }
`;

export const LargeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  .fix-margin {
    margin-top: -2.5rem;
  }
`;

export const AuxContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const GreenButton = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.accentGreen};
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  height: 6.2rem;
  justify-content: center;
  margin-top: 2rem;
  width: 43.1rem;
  h2 {
    color: ${({ theme }) => theme.colors.white};
    font-size: 1.6rem;
    font-weight: 700;
    margin-left: 1rem;
  }
  .icon {
    height: 5rem;
    width: 5rem;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  height: 12rem;
`;
